module.exports = __webpack_public_path__ + "img/badge_3.b89b6288.png";